import { FC, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

const AddNewEmployee: FC = () => {
  const [data, setData] = useState<{
    [key: string]: string;
  }>({
    birthday: "",
    jobTitle: "",
    name: "",
    patronymic: "",
    surname: "",
  });
  const [errorField, setErrorField] = useState<string[]>([]);

  const handleTextFieldChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;

    if (errorField.includes(name) && value.length > 0) {
      setErrorField(errorField.filter((elem) => elem !== name));
    }

    setData({ ...data, [name]: value });
  };

  const handleSubmit = () => {
    const errorArray: string[] = [];
    Object.keys(data).forEach((elem) => {
      if (!data[elem].length) {
        errorArray.push(elem);
      }
    });

    if (errorArray.length) {
      setErrorField(errorArray);
    } else {
      setErrorField([]);
      console.log("data", data);
    }
  };

  return (
    <Box display="flex" flexDirection="column" gap={1.5}>
      <TextField
        label="Фамилия"
        variant="outlined"
        name="surname"
        onChange={(event) => handleTextFieldChange(event)}
        error={errorField.includes("surname")}
      />
      <TextField
        label="Имя"
        variant="outlined"
        name="name"
        onChange={(event) => handleTextFieldChange(event)}
        error={errorField.includes("name")}
      />
      <TextField
        label="Отчество"
        variant="outlined"
        name="patronymic"
        onChange={(event) => handleTextFieldChange(event)}
        error={errorField.includes("patronymic")}
      />
      <TextField
        label="Должность"
        variant="outlined"
        name="jobTitle"
        onChange={(event) => handleTextFieldChange(event)}
        error={errorField.includes("jobTitle")}
      />
      <TextField
        label="Дата рождения"
        type="date"
        name="birthday"
        onChange={(event) => handleTextFieldChange(event)}
        error={errorField.includes("birthday")}
        InputLabelProps={{ shrink: true }}
      />
      <Button variant="contained" onClick={handleSubmit}>
        Создать
      </Button>
    </Box>
  );
};

export default AddNewEmployee;
